export function dropUnderscoreRouteParts(path: string): string {
	// This regex removes underscore-prefixed parts from URLs while
	// preserving the (non)existence of trailing slashes (only exception is "_foo/" -> "").
	// https://regex101.com/r/OfPJgy/1
	const cleaned = path.replaceAll(/\b_[-\w]*\/?|(?<!^)\/\b_[-\w]*$/g, '');
	return cleaned.startsWith('/') ? cleaned : `/${cleaned}`;
}

export function removeTrailingSlash(path: string): string {
	return path.replace(/\/$/, '');
}

export function ensureLeadingSlash(str: string): string {
	return str.startsWith('/') ? str : `/${str}`;
}

export function joinPublicPath(...parts: string[]): string {
	const segments = parts
		.flatMap((part) => part.split('/'))
		.filter(Boolean);

	return `/${segments.join('/')}`;
}
